/** App router base path (e.g. "" locally, "/frontend" in production). */
export function appBasePath(): string {
  return (import.meta.env.BASE_URL || "/").replace(/\/$/, "");
}

/** Full browser path to the login page, respecting Vite base path. */
export function loginPath(): string {
  const base = appBasePath();
  return base ? `${base}/login` : "/login";
}

export function isLoginPath(pathname = window.location.pathname): boolean {
  const login = loginPath();
  return pathname === login || pathname.endsWith("/login");
}
